@if (showSkeleton()) {
  <p-skeleton height="550px" width="100%"></p-skeleton>
} @else {

  <form [formGroup]="form">
    <div class="row my-2">
      <div class="col-12">
        <p class="fs-3 fw-medium mb-1">{{ payment?.renterFullName }}</p>
        <p>
          {{ 'INVOICES.INVOICENUMBER' | translate }}: <span class="fw-bolder">{{ payment?.invoiceNumber }}</span><br>
          {{ 'PAYMENT.PURPOSE_OF_USE' | translate }}:<span class="fw-bolder"> {{ payment?.details }}</span>
        </p>
      </div>
      <div class="col-12">
        <p class="text-dark fs-4">
          {{ 'PAYMENT.GROSS_AMOUNT' | translate }}:
          <span class="text-primary fw-bold"><i class="las la-euro-sign me-1"></i>{{ payment.amount }}</span>
        </p>
        <hr>
      </div>

      <div class="col-6">
        <p class="mb-1 text-muted">{{ 'PAYMENT.BOOKING_DATE' | translate }}</p>
        <p class="mb-2 fs-5">{{ payment?.date }}</p>
      </div>

      <div class="col-6">
        <p class="mb-1 text-muted">{{ 'PAYMENT.PERIOD_CORRESPONDING' | translate }}</p>
        <p class="mb-2 fs-5">{{ payment?.period| date:'YYYY-MM-dd' }}</p>
      </div>

      <div class="col-6">
        <p class="mb-1 text-muted">{{ 'PAYMENT.PAYMENT_TYPE' | translate }}</p>
        <p class="mb-0 fs-5">{{ "PAYMENT.TYPES." +payment?.type | translate }}</p>
      </div>

      <div class="col-6">
        <p class="mb-1 text-muted">{{ 'METER.STATUS' | translate }}</p>
        <p class="mb-0 fs-5">
          {{ ("INVOICES.PAYMENT_STATUSES." + payment?.status) | translate }}
        </p>
      </div>
    </div>
    <div class="col-12 gap-2 mt-3 text-end">
      <button type="button" class="btn btn-light" (click)="cancel()">
        {{ 'CLOSE' | translate }}
      </button>
    </div>

  </form>
}
